import React, { useEffect, useState } from "react";

import "react-multi-carousel/lib/styles.css";
import Layout from "../../components/Layout.js";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import { motion } from "framer-motion";
import arrowRArrowRight from "../../assets/icons/right-svgrepo-com.svg";
import iconFlash from "../../assets/IconeSvg/lightning-svgrepo-com.svg";
import iconLogo from "../../assets/icons/favicon-3.png";
import { RiWhatsappLine } from "react-icons/ri";
import { NavLink, useNavigate } from "react-router";
import Carousel from "react-multi-carousel";
import {
  listeDesproductSansFiltre,
  VisitorCompteurproduct
} from "../../services/produits/ProduitsRequest.js";
import { listeCategoriesSansFiltre } from "../../services/parametrage/CategorieRequest.js";
import { IterationCcw } from "lucide";
import { listeDesPosters } from "../../services/parametrage/PostersRequest.js";
import { IoIosArrowForward } from "react-icons/io";

const responsive = {
  desktop: {
    breakpoint: {
      max: 3000,
      min: 1024
    },
    items: 5,
    partialVisibilityGutter: 40
  },
  mobile: {
    breakpoint: {
      max: 464,
      min: 0
    },
    items: 3,
    partialVisibilityGutter: 30
  },
  tablet: {
    breakpoint: {
      max: 1024,
      min: 464
    },
    items: 3,
    partialVisibilityGutter: 30
  }
};

const responsive2 = {
  desktop: {
    breakpoint: {
      max: 3000,
      min: 1024
    },
    items: 5,
    partialVisibilityGutter: 40
  },
  mobile: {
    breakpoint: {
      max: 464,
      min: 0
    },
    items: 2,
    partialVisibilityGutter: 30
  },
  tablet: {
    breakpoint: {
      max: 1024,
      min: 464
    },
    items: 4,
    partialVisibilityGutter: 30
  }
};

const Home = () => {
  const navigate = useNavigate();

  const [listeTelephone, setListeTelephone] = useState([]);
  const [listeTelevision, setListeTelevision] = useState([]);
  const [eletromenagers, setEletromenagers] = useState([]);
  const [loadingData, setLoadingData] = useState(false);

  const [listFlashPromo, setListFlashPromo] = useState("");
  const [listeCategorie, setListeCategorie] = useState([]);
  const [listeCompletProduits, setListeCompletProduits] = useState([]);
  const [banniereList, setBanniereList] = useState([]);
  const [displayPoster, setDisplayPoster] = useState([]);

  const [productsByCategory, setProductsByCategory] = useState({});

  const calculateTimeLeft = (finSolde) => {
    const now = Date.now(); // timestamp actuel en ms
    const end = new Date(finSolde).getTime(); // timestamp de la date d'expiration
    // finSolde
    const difference = end - now; // ms restants

    if (difference > 0) {
      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)), // jours restants
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24), // heures restantes
        minutes: Math.floor((difference / (1000 * 60)) % 60), // minutes restantes
        seconds: Math.floor((difference / 1000) % 60), // secondes restantes
        isExpired: false
      };
    }

    // Échu
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      isExpired: true
    };
  };

  const PromotionCard = ({ item }) => {
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(item.finSolde));
    const now = Date.now(); // timestamp actuel en ms
    const end = new Date(item.finSolde).getTime(); // timestamp de la date d'expiration
    useEffect(() => {
      const timer = setInterval(() => {
        setTimeLeft(calculateTimeLeft(item.finSolde));
      }, 1000);

      return () => clearInterval(timer);
    }, [item]);

    return (
      <div
        onClick={() => counterVisitorClick(item._id)}
        className="relative flex xl:w-[230px] lg:w-[230px] md:w-[230px] w-[170px] gap-y-3 flex-col cursor-pointer  bg-white rounded-2xl border-[1px]  p-2 border-red-300"
      >
        <div className="w-full flex items-center justify-center">
          <img
            src={item.images[0]}
            className="xl:w-[120px] lg:w-[120px] md:w-[120px] w-full  h-"
            alt="Product"
          />
        </div>
        <div className="flex flex-col gap-y-2 justify-between">
          <p className="text-gray-600  text-md truncate">{item.name}</p>
          <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col justify-start items-start px-1 gap-1 ">
            <h2 className="text-md text-secondary font-semibold">
              {item.prixSolde && <h2>{item.prix - item.prixSolde} FCFA</h2>}
            </h2>
            {item.prixSolde && <del className="">{item.prix} FCFA</del>}
          </div>
          {end > now ? (
            <div className="">
              <h1 className="text-sm font-semibold text-gray-800 text-wrap">
                expire dans :
              </h1>
              <div className="grid grid-flow-col  mt-2 items-center text-center  text-sm  lg:auto-cols-max xl:auto-cols-max md:auto-cols-max auto-cols-">
                {/* Jours */}
                <div className="flex flex-col p-1 bg-neutral  rounded-lg justify-center items-center text-neutral-content">
                  <span className="countdown font-mono ">
                    <span style={{ "--value": timeLeft.days }}></span>
                  </span>
                  Jrs
                </div>
                <span className="text-xl font-semibold rounded-lg text-black">
                  :
                </span>
                {/* Heures */}
                <div className="flex flex-col p-1 bg-neutral rounded-lg justify-center items-center text-neutral-content">
                  <span className="countdown font-mono ">
                    <span style={{ "--value": timeLeft.hours }}></span>
                  </span>
                  Hrs
                </div>
                <span className="text-xl font-semibold rounded-lg text-black">
                  :
                </span>

                {/* Minutes */}
                <div className="flex flex-col p-1 bg-neutral rounded-lg justify-center items-center text-neutral-content">
                  <span className="countdown font-mono ">
                    <span style={{ "--value": timeLeft.minutes }}></span>
                  </span>
                  Min
                </div>
                <span className="text-xl font-semibold rounded-lg text-black">
                  :
                </span>
                {/* Secondes */}
                <div className="flex flex-col p-1 bg-neutral rounded-lg justify-center items-center text-neutral-content">
                  <span className="countdown font-mono text-md">
                    <span style={{ "--value": timeLeft.seconds }}></span>
                  </span>
                  Sec
                </div>
              </div>
            </div>
          ) : (
            <h2 className="text-red-600 font-bold">Fin de la promotion</h2>
          )}
        </div>
        <div className="absolute top-1 right-1">
          <h3 className="text-red-600 font-bold text-xl xl:bg-transparent  lg:bg-transparent md:bg-transparent bg-white p-3 rounded-xl ">
            -{item.pourcentageSolde}%
          </h3>
        </div>
      </div>
    );
  };

  const SkeletonPromotion = () => {
    const skeletonItems = Array.from({ length: 7 }); // Nombre d'éléments skeleton à afficher
    return (
      <div className="flex flex-row gap-x-8">
        {skeletonItems.map((_, index) => (
          <div
            key={index}
            className="w-52 bg-white flex flex-col justify-between shadow-md rounded-xl duration-500 hover:scale-105 hover:shadow-xl relative"
          >
            <div className="p-4">
              <div className="skeleton h-40 w-full object-contain rounded-t-xl relative flex justify-center items-center">
                <img src={iconLogo} alt="" className="animate-bounce" />
              </div>
              <div className="skeleton h-3 w-24 my-2"></div>
              <div className="skeleton h-3 w-28 my-2"></div>

              <div className="skeleton h-3 w-32 my-2"></div>
              <div className="skeleton h-3 w-32 my-2"></div>
            </div>

            <h2 className="skeleton rounded-lg px-2 py-2 w-8 h-8 absolute top-1 right-1"></h2>
          </div>
        ))}
      </div>
    );
  };

  const SkeletonCategorie = () => {
    const skeletonItems = Array.from({ length: 6 }); // Nombre d'éléments skeleton à afficher
    return (
      <div className="flex flex-row gap-x-4">
        {skeletonItems.map((_, index) => (
          <div
            key={index}
            className="flex xl:flex-row lg:flex-row md:flex-row flex-col gap-y-3 gap-2  justify-between items-center  "
          >
            <div className="skeleton w-24 h-20 flex justify-center items-center  object-cover rounded-t-xl relative">
              <img src={iconLogo} alt="" className="animate-bounce" />
            </div>
            <div className="skeleton flex flex-row justify-between items-center px-2   w-24  h-3  "></div>
          </div>
        ))}
      </div>
    );
  };

  const SkeletonCategorySection = () => {
    return (
      <>
        <div className="flex lg:flex-row xl:flex-row md:flex-row flex-col mb-3 bg-green-100 py-3 justify-between lg:items-center xl:items-center md:items-center gap-3 w-full px-6 mt-[4rem]">
          <div className="skeleton h-8 w-48"></div>
          <div className="skeleton h-10 w-32"></div>
        </div>
        <div className="w-full grid px-3 gap-2 xl:grid-cols-6 lg:grid-cols-5 md:grid-cols-3 grid-cols-2">
          <SkeletonPromotion />
        </div>
      </>
    );
  };

  const onSubmit = (slide) => {
    const message = `${slide.description}\n\nJe souhaite avoir des informations svp ? Merci`;
    if (message) {
      const url = `https://wa.me/${"+2250564021616"}?text=${encodeURIComponent(
        message
      )}`;
      window.open(url, "_blank");
    } else {
      alert("Please insert message to send");
    }
  };

  const getListeDesCategories = () => {
    listeCategoriesSansFiltre()
      .then((res) => {
        setListeCategorie(res.data.categories);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const counterVisitorClick = (id) => {
    VisitorCompteurproduct(id)
      .then((res) => {
        console.log(res.data);
        navigate(`/product-details/${id}`);
        console.log("compteur incrementé");
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  useEffect(() => {
    getListeDesCategories();
  }, []);

  useEffect(() => {
    setLoadingData(true);
    const now = Date.now();

    Promise.all([
      listeDesproductSansFiltre(),
      listeCategoriesSansFiltre(),
      listeDesPosters(1, 100, "")
    ])
      .then(([productsRes, categoriesRes, postersRes]) => {
        setLoadingData(false);
        const products = productsRes.data.products;
        const categories = categoriesRes.data.categories;
        const posters = postersRes.data.posters;

        setListeCompletProduits(products);
        setListeCategorie(categories);

        // Gestion des produits en vedette
        // const vedettes = products.filter((items) => items.enVedette === true);
        const vedettes = products
          .filter((item) => item.enVedette === true)
          .sort((a, b) => {
            const da = a.created_at ? new Date(a.created_at).getTime() : 0;
            const db = b.created_at ? new Date(b.created_at).getTime() : 0;
            return db - da; // plus récent d'abord
          });

        const listePosters = posters
          .filter((item) => new Date(item.timeEnd).getTime() >= Date.now())
          .sort((a, b) => {
            const da = a.created_at ? new Date(a.created_at).getTime() : 0;
            const db = b.created_at ? new Date(b.created_at).getTime() : 0;
            return db - da; // plus récent d'abord
          });
        console.log("posters :", listePosters);

        // console.table(vedettes)
        setBanniereList(vedettes);

        setDisplayPoster(listePosters);

        // Gestion des promotions flash
        const flashPromo = products.filter(
          (items) =>
            items.enSolde === true && new Date(items.finSolde).getTime() > now
        );
        setListFlashPromo(flashPromo);

        // Regroupement des produits par catégorie
        const groupedProducts = products.reduce((acc, product) => {
          if (product.categorie && product.categorie.nom) {
            if (!acc[product.categorie.nom]) {
              acc[product.categorie.nom] = [];
            }
            acc[product.categorie.nom].push(product);
          }
          return acc;
        }, {});

        setProductsByCategory(groupedProducts);

        // Mise à jour des états spécifiques pour la rétrocompatibilité
        setListeTelephone(groupedProducts["Téléphone"] || []);
        setListeTelevision(groupedProducts["Télévision"] || []);
        setEletromenagers([
          ...(groupedProducts["Grands Electromenagers"] || []),
          ...(groupedProducts["Petits Electromenagers"] || [])
        ]);
      })
      .catch((error) => {
        setLoadingData(false);
        console.log("error", error);
      });
  }, []);

  const CategorySection = ({
    title,
    products,
    loadingData,
    onViewMore,
    onProductClick
  }) => {
    if (!products || products.length === 0) return null;

    return (
      <>
        <div className="flex lg:flex-row xl:flex-row md:flex-row flex-col mb-3 bg-green-100 py-3 justify-between lg:items-center xl:items-center md:items-center gap-3 w-full px-6 mt-[4rem]">
          <h2 className="text-gray-800 font-bold text-2xl text-nowrap truncate">
            <span className="text-gray-600 xl:text-lg ld:text-lg md:text-md text-sm font-semibold">
              {title}
            </span>
          </h2>
          {products.length > 12 && (
            <button
              onClick={onViewMore}
              className="flex flex-row items-center justify-center text-nowrap bg-secondary text-white font-bold py-3 px-6 rounded-lg"
            >
              <span>Voir plus</span>
              <img src={arrowRArrowRight} className="w-6" alt="" />
            </button>
          )}
        </div>
        <div className="w-full grid px-3 gap-2 xl:grid-cols-6 lg:grid-cols-5 md:grid-cols-3 grid-cols-2">
          {!loadingData ? (
            products.slice(0, 12).map((item, i) => (
              <div
                key={i}
                onClick={() => onProductClick(item._id)}
                className="xl:w-52 cursor-pointer lg:w-52 md:w-52 w-40 bg-white shadow-md flex flex-col justify-between pb-4 rounded-xl duration-500 hover:scale-105 hover:shadow-xl relative"
              >
                <div className="flex flex-col justify-between items-start h-full">
                  <img
                    src={item.images[0]}
                    alt="Product"
                    className="h-40 w-full object-contain rounded-t-xl"
                  />
                  <div className="w-full">
                    <div className="flex flex-row justify-between items-center px-4 py-3">
                      <span className="text-gray-600 mr-3 font-semibold uppercase text-md truncate">
                        {item.name}
                      </span>
                    </div>
                    <div className="flex flex-col justify-start items-start px-4">
                      <h2 className="text-md text-secondary font-semibold">
                        {item.prixSolde ? (
                          <h2>{item.prix - item.prixSolde} FCFA</h2>
                        ) : (
                          <h2>{item.prix} FCFA</h2>
                        )}
                      </h2>
                      {item.prixSolde && (
                        <del className="">{item.prix} FCFA</del>
                      )}
                    </div>
                  </div>
                  <span className="text-gray-400 text-xs px-4">
                    {item.stock} en stock
                  </span>
                </div>
                {item.pourcentageSolde && item.pourcentageSolde !== 0 ? (
                  <h2 className="absolute top-1 right-1 text-md font-bold bg-[#7ace73c5] py-2 px-1 rounded-xl text-primary truncate block capitalize">
                    -{item.pourcentageSolde}%
                  </h2>
                ) : null}
              </div>
            ))
          ) : loadingData ? (
            <SkeletonPromotion />
          ) : (
            <span className="text-red-600 italic font-semibold text-sm">
              Erreur connexion internet instable
            </span>
          )}
        </div>
      </>
    );
  };

  return (
    <Layout>
      <div className="flex flex-col w-full">
        {!loadingData ? (
          banniereList.length > 0 && displayPoster.length === 0 ? (
            <Swiper
              modules={[Pagination, Autoplay, Navigation]}
              navigation={true}
              direction="horizontal"
              pagination={{
                clickable: true
              }}
              autoplay={{
                delay: 7000,
                disableOnInteraction: false
              }}
              speed={1200} // Réduire la vitesse pour des transitions plus douces
              className="lg:h-[450px] md:h-[450px] h-[600px] w-full  custom-green-gradient"
            >
              {banniereList.length > 0 &&
                banniereList.map((slide, index) => {
                  // Extraction des valeurs une seule fois
                  const typeProduit =
                    (slide.specifications &&
                      slide.specifications.find(
                        (el) => el.spec === "Type de produit"
                      )?.value) ||
                    "";
                  const garantie =
                    (slide.specifications &&
                      slide.specifications.find((el) => el.spec === "Garantie")
                        ?.value) ||
                    "";
                  return (
                    <SwiperSlide key={index}>
                      {({ isActive }) => (
                        <div
                          className={`flex lg:flex-row md:flex-row flex-col px-4 items-center justify-center h-full w-full  `}
                        >
                          <div className="lg:hidden md:hidden flex  items-center justify-center py-2 ">
                            <motion.img
                              src={slide.images && slide.images[0]}
                              alt={slide._id}
                              className=" flex  rounded-lg object-contain w-[300px] mt-[-2rem] h-[300px] "
                              initial={{ opacity: 0, x: -50 }}
                              animate={
                                isActive
                                  ? { opacity: 1, x: 0 }
                                  : { opacity: 0, x: -50 }
                              }
                              transition={{ duration: 1 }}
                            />
                          </div>

                          <div className="relative flex flex-col justify-start items-start lg:mt- md:mt- mt-5  lg:w-1/2 md:w-1/2 w-full">
                            <motion.h2
                              className=" lg:text-[30px] md:text-[30px] text-[20px] font-bold text-gray-800"
                              initial={{ opacity: 0, y: -20 }}
                              animate={
                                isActive
                                  ? { opacity: 1, y: 0 }
                                  : { opacity: 0, y: -20 }
                              }
                              transition={{ duration: 1.2 }}
                            >
                              {slide.name} {/* On n'affiche que si non vide */}
                              {typeProduit && ` — ${typeProduit}`}
                              {garantie && ` • Garantie : ${garantie}`}
                            </motion.h2>
                            <div className="flex flex-row xl:justify-start lg:justify-start  justify-between items-center w-full">
                              <motion.h2
                                className="lg:text-2xl md:text-2xl text-lg text-[#00000080] italic "
                                initial={{ opacity: 0, y: 20 }}
                                animate={
                                  isActive
                                    ? { opacity: 1, y: 0 }
                                    : { opacity: 0, y: 20 }
                                }
                                transition={{ duration: 1.5 }}
                              >
                                {slide.marque && slide.marque.nom}
                              </motion.h2>
                              <motion.h2
                                className=" lg:text-[30px] md:text-[30px] text-[20px] xl:ml-[18rem] lg:ml-[18rem] ml-  font-bold text-red-600"
                                initial={{ opacity: 0, y: -20 }}
                                animate={
                                  isActive
                                    ? { opacity: 1, y: 0 }
                                    : { opacity: 0, y: -20 }
                                }
                                transition={{ duration: 1.2 }}
                              >
                                -{" "}
                                {slide.pourcentageSolde &&
                                  slide.pourcentageSolde}
                                % {/* On n'affiche que si non vide */}
                              </motion.h2>
                            </div>
                            <motion.h2
                              className=" lg:text-[40px] md:text-[40px] text-[20px] flex flex-row items-center gap-2  font-bold text-secondary"
                              initial={{ opacity: 0, y: -20 }}
                              animate={
                                isActive
                                  ? { opacity: 1, y: 0 }
                                  : { opacity: 0, y: -20 }
                              }
                              transition={{ duration: 1.2 }}
                            >
                              {slide.prixSolde ? (
                                <>
                                  <span>
                                    {slide.prix - slide.prixSolde} FCFA
                                  </span>
                                  <del className="text-[30px] text-gray-300">
                                    {slide.prix} FCFA
                                  </del>
                                </>
                              ) : (
                                <span>{slide.prix} FCFA</span>
                              )}
                            </motion.h2>

                            <button
                              onClick={() =>
                                navigate(`/product-details/${slide._id}`)
                              }
                              className="lg:mt-[5rem] md:mt-[5rem] mt-[2rem]  bg-primary rounded-lg py-2 px-4 font-semibold text-white"
                            >
                              En savoir plus
                            </button>
                          </div>

                          <div className="lg:flex md:flex hidden  items-center justify-center  rounded-bl-[8rem]  py-4 px-6">
                            <motion.img
                              src={slide.images && slide.images[0]}
                              alt={slide.title}
                              className="lg:flex md:flex hidden  w-[400px] object-contain  h-[400px]"
                              initial={{ opacity: 0, x: -50 }}
                              animate={
                                isActive
                                  ? { opacity: 1, x: 0 }
                                  : { opacity: 0, x: -50 }
                              }
                              transition={{ duration: 1 }}
                            />
                          </div>
                        </div>
                      )}
                    </SwiperSlide>
                  );
                })}
            </Swiper>
          ) : (
            <Swiper
              modules={[Pagination, Autoplay, Navigation]}
              navigation={true}
              direction="horizontal"
              pagination={{
                clickable: true
              }}
              autoplay={{
                delay: 7000,
                disableOnInteraction: false
              }}
              speed={1200} // Réduire la vitesse pour des transitions plus douces
              className="w-full h-full"
            >
              {displayPoster.map((slide, index) => (
                <SwiperSlide key={index}>
                  {({ isActive }) => (
                    <div className="relative ">
                      <img
                        src={slide.image}
                        alt="poster"
                        className="w-full xl:h-[450px] lg:h-[450px] md:h-[450px]  h-[200px] "
                      />
                      {/* <button
                        onClick={() => onSubmit(slide)}
                        className="absolute bottom-1 right-1 flex z-50 flex-row justify-center items-center cursor-pointer text-white bg-black rounded-md text-sm py-2 px-4 font-semibold space-x-2"
                      >
                        <RiWhatsappLine className="text-lg font-semibold" />
                        <span>En savoir plus</span>
                        <IoIosArrowForward className="text-white font-semibold text-lg" />
                      </button> */}
                    </div>
                  )}
                </SwiperSlide>
              ))}
            </Swiper>
          )
        ) : (
          <div className="skeleton flex justify-center items-center lg:h-[450px] md:h-[450px] h-[500px] w-full rounded-t-xl relative">
            <img src={iconLogo} alt="" className="animate-bounce" />
          </div>
        )}

        <div className="flex flex-col justify-center my-4 items-center w-full">
          <div className="flex flex-col justify-center items-center gap-1">
            <h2 className="text-black font-semibold leading-6 text-xl  px-4">
              Nos catégories
            </h2>
            <span className="w-10 rounded-3xl bg-black h-[2px]"></span>
          </div>

          {/* J ai actuellenent trois catégorie */}
        </div>
        <div className="">
          <Carousel
            additionalTransfrom={0}
            arrows
            autoPlaySpeed={3000}
            centerMode={false}
            // className=" py-8 flex   "
            className={`${
              listFlashPromo.length < 4
                ? "flex  justify-center items-center"
                : ""
            } py-8`}
            containerClass="container-with-dots"
            dotListClass=""
            draggable
            focusOnSelect={false}
            infinite
            itemClass=""
            keyBoardControl
            minimumTouchDrag={80}
            pauseOnHover
            renderArrowsWhenDisabled={false}
            renderButtonGroupOutside={false}
            renderDotsOutside={false}
            responsive={responsive}
            rewind={false}
            rewindWithAnimation={false}
            rtl={false}
            shouldResetAutoplay
            showDots={false}
            sliderClass=""
            slidesToSlide={1}
            swipeable
          >
            {listeCategorie && !loadingData ? (
              listeCategorie.map((item, i) => (
                <button
                  key={i}
                  className="xl:w-[250px] lg:w-[250px] md:w-[250px] w-[110px]   rounded-xl duration-500 hover:scale-105 bg-white py-1 px-2  gap-x-5 hover:shadow-xl"
                >
                  <div
                    onClick={() => navigate(`/allproduits/${item.nom}`)}
                    className="gap-2 cursor-pointer"
                  >
                    <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col gap-y-3  justify-between items-center  ">
                      <img
                        src={item.image}
                        alt="Product"
                        className="w-24 h-20  object-cover rounded-t-xl"
                      />
                      <div className="flex flex-row justify-between items-center px-2    ">
                        <span className="text-gray-600 font-semibold  uppercase xl:text-xs lg:text-xs md:text-xs text-[8px]">
                          {item.nom}
                        </span>
                      </div>
                    </div>
                  </div>
                </button>
              ))
            ) : loadingData ? (
              <SkeletonCategorie />
            ) : (
              <span className="text-red-600 italic font-semibold text-sm">
                Erreur connextion internet instable
              </span>
            )}
          </Carousel>
        </div>

        {listFlashPromo.length > 0 && (
          <>
            <div className="flex lg:flex-row xl:flex-row md:flex-row flex-col justify-between  lg:items-center xl:items-center md:items-center  gap-3 w-full px-6">
              <div className="bg-red-600 flex flex-row justify-center items-center gap-1  py-2 px-6 w-fit">
                <h2 className="text-nowrap text-xl font-bold  text-white">
                  Promo Flash
                </h2>
                <img src={iconFlash} className="w-6" alt="" />
              </div>
              <hr className="h-[2px] w-full bg- lg:block xl:block md:block hidden" />

              {listFlashPromo.length > 7 && (
                <button
                  onClick={() => navigate(`/allproduits/enSolde`)}
                  className=" flex flex-row items-center justify-center  text-nowrap bg-secondary text-white font-bold py-3 px-6 rounded-lg"
                >
                  <span> Voir plus</span>
                  <img src={arrowRArrowRight} className="w-6" alt="" />
                </button>
              )}
            </div>
            <div className="mt-[2rem] ">
              <Carousel
                additionalTransfrom={0}
                arrows
                autoPlay
                autoPlaySpeed={4000}
                centerMode={false}
                // className={`${
                //   listFlashPromo.length < 5
                //     ? "flex  justify-center items-center"
                //     : ""
                // }`}
                containerClass="container-with-dots"
                // customTransition="all 1s linear"
                dotListClass=""
                draggable
                focusOnSelect={false}
                infinite={true}
                itemClass=""
                keyBoardControl
                minimumTouchDrag={80}
                pauseOnHover
                renderArrowsWhenDisabled={false}
                renderButtonGroupOutside={false}
                renderDotsOutside={false}
                responsive={responsive2}
                rewind={false}
                rewindWithAnimation={false}
                rtl={false}
                shouldResetAutoplay
                showDots={false}
                sliderClass=""
                slidesToSlide={2}
                swipeable
                // transitionDuration={4000}
              >
                {listFlashPromo && !loadingData ? (
                  listFlashPromo.map((item, i) => (
                    <>
                      <PromotionCard key={i} item={item} />
                    </>
                  ))
                ) : loadingData ? (
                  <SkeletonPromotion />
                ) : (
                  <span className="text-red-600 italic font-semibold text-sm">
                    Erreur connextion internet instable
                  </span>
                )}
              </Carousel>
            </div>
          </>
        )}

        {/* Sections de catégories dynamiques */}
        {loadingData ? (
          // Afficher 4 sections skeleton pendant le chargement
          <>
            <SkeletonCategorySection />
            <SkeletonCategorySection />
            <SkeletonCategorySection />
            <SkeletonCategorySection />
          </>
        ) : (
          Object.entries(productsByCategory).map(([categoryName, products]) => {
            if (products.length === 0) return null;

            return (
              <CategorySection
                key={categoryName}
                title={`Nos offres | ${categoryName}`}
                products={products}
                loadingData={loadingData}
                onViewMore={() => navigate(`/allproduits/${categoryName}`)}
                onProductClick={counterVisitorClick}
              />
            );
          })
        )}
      </div>
    </Layout>
  );
};

export default Home;
